import { create } from "zustand";

interface NewReportsStore {
  /** 방금 업로드됐고 아직 열어보지 않은 워크북 id */
  ids: Set<string>;
  mark: (workbookId: string) => void;
  clear: (workbookId: string) => void;
}

/**
 * 방금 올린 보고서가 목록 어디에 생겼는지 표시하기 위한 기억.
 *
 * 기간이 많은 사용자는 업로드가 끝나도 새 파일이 어느 연도에 들어갔는지 알 수 없다.
 * 업로드가 끝난 워크북 id 를 여기 적어 두면 목록이 그 연도 탭과 보고서 줄에 점을
 * 찍어 준다. 보고서를 한 번 열면 지운다.
 *
 * 새로고침하면 사라지는 화면용 기억이다 — 서버에 남길 만한 상태가 아니다.
 */
export const useNewReportsStore = create<NewReportsStore>()((set) => ({
  ids: new Set<string>(),
  mark: (workbookId) =>
    set((state) => {
      const next = new Set(state.ids);
      next.add(workbookId);
      return { ids: next };
    }),
  clear: (workbookId) =>
    set((state) => {
      if (!state.ids.has(workbookId)) return state;
      const next = new Set(state.ids);
      next.delete(workbookId);
      return { ids: next };
    }),
}));

export const markNewReport = (workbookId: string) =>
  useNewReportsStore.getState().mark(workbookId);

export const clearNewReport = (workbookId: string) =>
  useNewReportsStore.getState().clear(workbookId);
